"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Hero1;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Heading = _interopRequireDefault(require("./Heading3.js"));

var _CardInfoIcon = _interopRequireDefault(require("./CardInfoIcon.js"));

var _InfoAreaIconTitleLink = _interopRequireDefault(require("./InfoAreaIconTitleLink.js"));

var _CardBlogImage = _interopRequireDefault(require("./CardBlogImage.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
function Hero1(_ref) {
  var heading3 = _ref.heading3,
      infoCards = _ref.infoCards,
      infoArea = _ref.infoArea,
      skewCard = _ref.skewCard;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("section", {
    className: "pb-20 bg-blueGray-100"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container mx-auto px-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pt-6"
  }, heading3 && /*#__PURE__*/_react.default.createElement(_Heading.default, heading3)), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap"
  }, infoCards.map(function (prop, key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center",
      key: key
    }, /*#__PURE__*/_react.default.createElement(_CardInfoIcon.default, prop));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap items-center mt-32"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full md:w-5/12 px-4 mr-auto ml-auto"
  }, /*#__PURE__*/_react.default.createElement(_InfoAreaIconTitleLink.default, infoArea)), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full md:w-4/12 px-4 mr-auto ml-auto"
  }, /*#__PURE__*/_react.default.createElement(_CardBlogImage.default, skewCard))))));
}

Hero1.defaultProps = {
  heading3: null,
  infoCards: [],
  infoArea: {},
  skewCard: {}
};
Hero1.propTypes = {
  // prop to pass to the Heading3 component
  heading3: _propTypes.default.object,
  // it is represented by the props
  // that can be passed to the CardInfoIcon,
  // so please check that one out
  infoCards: _propTypes.default.arrayOf(_propTypes.default.object),
  // it is represented by the props
  // that can be passed to the InfoAreaIconTitleLink,
  // so please check that one out
  infoArea: _propTypes.default.object,
  // it is represented by the props
  // that can be passed to the CardBlogImage,
  // so please check that one out
  skewCard: _propTypes.default.object
};
